// extracted by mini-css-extract-plugin
export var avatar = "_nc-3";
export var avatarContainer = "_nc-2";
export var avatarSpacer = "_nc-5";
export var avatarSpacerContainer = "_nc-4";
export var avatarStackContainer = "_nc-1";
export var bubble = "_nc-0";
export var remainderBubble = "_nc-6";